import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { useOrientationChange } from '@ezugi/hooks/src/useOrientationChange';

const ConditionalPortalWrapped = ({ target, shouldUsePortal, children }) => {
  const [ targetRef, setTargetRef ] = useState(null);
  const orientation = useOrientationChange();

  useEffect(() => {
    setTargetRef(document.querySelector(target));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ orientation ]);

  if (!target || !shouldUsePortal) return children;

  return targetRef ? createPortal(children, targetRef) : null;
};

export { ConditionalPortalWrapped };
